import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryOneThirdIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.42 16.92H3.06V7H18.42V16.92ZM16.78 15.28V8.64H7.42L14.06 15.28H16.78ZM19.56 14.14V9.78C20.76 9.78 21.74 10.76 21.74 11.96C21.74 13.16 20.76 14.14 19.56 14.14Z" />
    </SvgIcon>
  );
});
